import styled, { keyframes } from 'styled-components';
import { SkeletonProps } from './Skeleton';

const animation = keyframes`
 0% {
    background-color: #f9f9f9;
  }
  100% {
    background-color: #dfdfdf;
  }
`;

export const Container = styled.div<SkeletonProps>`
	display: inline-block;
	animation: ${animation} 1s linear infinite alternate;
	border-radius: ${({ $borderRadius }) => ($borderRadius ? $borderRadius + 'px' : 0)};
	width: ${({ $width }) => ($width ? $width + 'px' : '100%')};
	height: ${({ $height }) => ($height ? $height + 'px' : '100%')};
`;
